module.exports = __webpack_public_path__ + "img/nelson-pro.f016578b.jpg";